module.exports = __webpack_public_path__ + "img/icon-a-4.26016854.svg";